module.exports = __webpack_public_path__ + "media/icons/i-7-users-bf802d8c.png";